// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tournamentTagsPage {
  width: 100%;
  min-height: calc(100vh - 76px);
  padding-bottom: 32px;
  background: var(--surface-page, #f8fafc);
  color: var(--text-body, #334155);
  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);
}
.tournamentTags__pageHeader {
  display: flex;
  width: calc(100% + 56px);
  min-height: 96px;
  align-items: center;
  justify-content: space-between;
  gap: 24px;
  margin: -20px 0 22px -28px;
  padding: 16px 28px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--surface-card, #fff);
}
.tournamentTags__heading {
  min-width: 0;
}
.tournamentTags__titleRow {
  display: flex;
  align-items: center;
  gap: 10px;
}
.tournamentTags__titleRow h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  font-weight: 800;
  line-height: 1.15;
}
.tournamentTags__heading p {
  max-width: 820px;
  margin: 6px 0 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.45;
}
.tournamentTags__mainCard {
  width: 100%;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 14px;
  background: var(--surface-card, #fff);
  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);
}
.tournamentTags__toolbar {
  display: flex;
  align-items: center;
  gap: 12px;
  flex-wrap: wrap;
  justify-content: space-between;
  padding: 0 0 14px;
}
.tournamentTags__toolbar h1 {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 24px;
  line-height: 1.15;
  font-weight: 800;
}
.tournamentTags__count {
  min-width: 28px;
  height: 22px;
  padding: 0 9px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 999px;
  background: var(--slate-150, #eef2f7);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 800;
}
.tournamentTags__search {
  width: 280px;
  height: 40px;
  margin-left: 0;
  padding: 0 12px;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
}
.tournamentTags__searchWrap {
  position: relative;
  width: 280px;
}
.tournamentTags__searchWrap .tournamentTags__search {
  width: 100%;
  padding-right: 38px;
}
.tournamentTags__searchWrap > button {
  position: absolute;
  top: 50%;
  right: 7px;
  width: 28px;
  height: 28px;
  padding: 0;
  transform: translateY(-50%);
  border: 0;
  border-radius: 7px;
  background: transparent;
  color: var(--text-muted, #64748b);
  font-size: 20px;
  line-height: 1;
  cursor: pointer;
}
.tournamentTags__searchWrap > button:hover {
  background: var(--surface-sunken, #f1f5f9);
  color: var(--text-strong, #0f172a);
}
.tournamentTags__search:focus {
  outline: 0;
  border-color: var(--brand-500, #287eb1);
  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);
}
.tournamentTags__create {
  margin-left: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
}
.tournamentTags__intro {
  max-width: 760px;
  margin: 8px 0 18px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.55;
}
.tournamentTags__error {
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid var(--red-100, #f9d4d9);
  border-radius: 8px;
  background: var(--red-50, #fdecee);
  color: var(--red-700, #a52836);
  font-size: 13px;
}
.tournamentTags__selection {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border: 1px solid var(--blue-100, #cfe5f2);
  border-radius: 8px;
  background: var(--blue-50, #eef7fc);
  color: var(--text-strong, #0f172a);
  font-size: 13px;
  font-weight: 700;
}
.tournamentTags__selection > div {
  display: flex;
  align-items: center;
  gap: 8px;
}
.tournamentTags__selection .sit-btn {
  display: inline-flex;
  align-items: center;
  gap: 7px;
}
.tournamentTags__card {
  overflow: visible;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: #fff;
  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));
}
.tournamentTags__table {
  width: 100%;
  border-collapse: separate;
  border-spacing: 0;
}
.tournamentTags__table th {
  padding: 11px 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  background: var(--slate-50, #f8fafc);
  color: var(--text-muted, #64748b);
  text-align: left;
  font-size: 11px;
  font-weight: 800;
  letter-spacing: 0.05em;
  text-transform: uppercase;
}
.tournamentTags__table th button {
  padding: 0;
  border: 0;
  background: transparent;
  color: inherit;
  font: inherit;
  letter-spacing: inherit;
  text-transform: inherit;
  cursor: pointer;
}
.tournamentTags__table th button span {
  margin-left: 5px;
}
.tournamentTags__table td {
  padding: 12px 14px;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0);
  color: var(--text-body, #334155);
  font-size: 13px;
  vertical-align: middle;
}
.tournamentTags__table tr:last-child td {
  border-bottom: 0;
}
.tournamentTags__table tbody tr {
  cursor: pointer;
  transition: background 0.15s ease;
}
.tournamentTags__table tbody tr:hover,
.tournamentTags__table tbody tr.isSelected {
  background: var(--slate-50, #f8fafc);
}
.tournamentTags__table tbody tr.tournamentTags__inlineRow {
  cursor: default;
  background: var(--blue-50, #f4f9fc);
}
.tournamentTags__inlineRow td {
  padding-top: 14px;
  padding-bottom: 14px;
  vertical-align: top;
}
.tournamentTags__inlineRow input[type='text'],
.tournamentTags__inlineRow input:not([type]),
.tournamentTags__inlineRow textarea {
  width: 100%;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: var(--text-strong, #0f172a);
  font: inherit;
}
.tournamentTags__inlineRow input[type='text'],
.tournamentTags__inlineRow input:not([type]) {
  height: 40px;
  padding: 0 12px;
}
.tournamentTags__inlineRow textarea {
  min-height: 72px;
  padding: 10px 12px;
  resize: vertical;
}
.tournamentTags__inlineRow input:focus,
.tournamentTags__inlineRow textarea:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.tournamentTags__inlineName em {
  display: block;
  margin-top: 5px;
  color: var(--red-600, #c4313f);
  font-size: 12px;
  font-style: normal;
}
.tournamentTags__swatches {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin-top: 10px;
}
.tournamentTags__swatch {
  width: 24px;
  height: 24px;
  padding: 0;
  border: 2px solid #fff;
  border-radius: 6px;
  box-shadow: 0 0 0 1px var(--border-default, #cbd5e1);
  cursor: pointer;
}
.tournamentTags__swatch.isActive {
  box-shadow: 0 0 0 2px var(--text-strong, #0f172a);
}
.tournamentTags__inlinePreview {
  margin-top: 10px;
}
.tournamentTags__publicToggle {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  min-height: 40px;
  margin: 0;
  color: var(--text-body, #334155);
  font-size: 13px;
  font-weight: 650;
}
.tournamentTags__publicToggle input {
  width: 17px;
  height: 17px;
  accent-color: var(--brand-600, #1f6f9f);
}
.tournamentTags__inlineActions {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
}
.tournamentTags__check {
  width: 44px;
  text-align: center !important;
}
.tournamentTags__check input {
  width: 16px;
  height: 16px;
  accent-color: var(--brand-600, #1f6f9f);
}
.tournamentTags__badge {
  min-height: 26px;
  padding: 0 10px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  gap: 7px;
  white-space: nowrap;
  font-size: 13px;
  font-weight: 600;
}
.tournamentTags__badge i {
  width: 8px;
  height: 8px;
  border-radius: 6px;
}
.tournamentTags__description {
  min-width: 240px;
  max-width: 560px;
  color: var(--text-muted, #64748b) !important;
}
.tournamentTags__visibility {
  min-height: 24px;
  padding: 0 9px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  background: var(--slate-150, #eef2f7);
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}
.tournamentTags__visibility.isPublic {
  background: var(--green-50, #edf8f2);
  color: var(--green-700, #287a50);
}
.tournamentTags__empty {
  padding: 32px 14px !important;
  text-align: center;
  color: var(--text-muted, #64748b) !important;
}
.tournamentTags__pagination {
  min-height: 56px;
  display: flex;
  align-items: center;
  justify-content: flex-end;
  gap: 8px;
  padding: 10px 0;
  color: var(--text-muted, #64748b);
  font-size: 13px;
}
.tournamentTagsDelete {
  display: flex;
  align-items: flex-start;
  gap: 13px;
  white-space: normal;
}
.tournamentTagsDelete__icon {
  flex: 0 0 auto;
  width: 36px;
  height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: 8px;
  background: var(--red-50, #fff1f2);
  color: var(--red-600, #c4313f);
  box-shadow: inset 0 0 0 1px var(--red-100, #ffd5da);
}
.tournamentTagsDelete p {
  margin: 0;
  color: var(--text-strong, #0f172a);
  font-size: 14px;
  font-weight: 700;
}
.tournamentTagsDelete__tags {
  display: flex;
  flex-wrap: wrap;
  gap: 7px;
  margin: 12px 0;
}
.tournamentTagsDelete .tournamentTagsDelete__note {
  color: var(--text-muted, #64748b);
  font-size: 13px;
  font-weight: 500;
  line-height: 1.5;
}
.tournamentTagsDeleteModal .modal-header {
  padding: 14px 18px !important;
}
.tournamentTagsDeleteModal .modal-body {
  padding: 18px !important;
}
.tournamentTagsDeleteModal .modal-footer {
  padding: 12px 18px !important;
}
.tournamentTagsDeleteModal .modal-footer .btn {
  min-height: 36px !important;
  padding: 0 14px !important;
  border-radius: 8px !important;
  font-size: 13px;
  font-weight: 700;
}
.tournamentTagsDeleteModal .modal-footer .btn-primary {
  border-color: var(--red-500, #da4453) !important;
  background: var(--red-500, #da4453) !important;
  color: #fff !important;
}
.tournamentTagsDeleteModal .modal-footer .btn-primary:hover {
  border-color: var(--red-600, #c4313f) !important;
  background: var(--red-600, #c4313f) !important;
}
.tournamentTagEditorModal .modal-content {
  border: 1px solid var(--border-subtle, #dbe3ec) !important;
  border-radius: 14px !important;
  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;
}
.tournamentTagEditorModal .modal-header {
  padding: 18px 20px 14px !important;
  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;
  background: #fff !important;
}
.tournamentTagEditorModal .modal-title {
  color: var(--text-strong, #0f172a);
  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);
  font-size: 19px;
  font-weight: 800;
}
.tournamentTagEditorModal .modal-body {
  padding: 0 !important;
  background: #fff;
}
.tournamentTagEditor {
  padding: 18px 20px 16px;
  color: var(--text-body, #334155);
}
.tournamentTagEditor__intro {
  margin-bottom: 17px;
  color: var(--text-muted, #64748b);
  font-size: 13px;
  line-height: 1.5;
}
.tournamentTagEditor__field {
  display: block;
  margin: 0 0 16px;
}
.tournamentTagEditor__field > span,
.tournamentTagEditor__label {
  display: block;
  margin-bottom: 6px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 700;
}
.tournamentTagEditor__field input,
.tournamentTagEditor__field textarea {
  width: 100%;
  border: 1px solid var(--border-default, #cbd5e1);
  border-radius: 8px;
  outline: 0;
  background: #fff;
  color: var(--text-strong, #0f172a);
  font: inherit;
}
.tournamentTagEditor__field input {
  height: 40px;
  padding: 0 12px;
}
.tournamentTagEditor__field textarea {
  min-height: 88px;
  padding: 10px 12px;
  resize: vertical;
}
.tournamentTagEditor__field input:focus,
.tournamentTagEditor__field textarea:focus {
  border-color: var(--border-brand, #6fb1df);
  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));
}
.tournamentTagEditor__field em {
  display: block;
  margin-top: 6px;
  color: var(--red-600, #c4313f);
  font-size: 12px;
  font-style: normal;
}
.tournamentTagEditor .tournamentTags__swatches {
  margin-top: 0;
}
.tournamentTagEditor__options {
  display: grid;
  grid-template-columns: minmax(180px, 0.8fr) minmax(260px, 1.2fr);
  gap: 18px;
  align-items: center;
  margin-top: 2px;
  padding: 14px;
  border: 1px solid var(--border-subtle, #e2e8f0);
  border-radius: 10px;
  background: var(--slate-50, #f8fafc);
}
.tournamentTagEditor__options .tournamentTags__publicToggle {
  align-items: flex-start;
  min-height: 0;
}
.tournamentTagEditor__options .tournamentTags__publicToggle > span {
  display: flex;
  flex-direction: column;
  gap: 3px;
  color: var(--text-muted, #64748b);
  font-size: 12px;
  font-weight: 500;
  line-height: 1.4;
}
.tournamentTagEditor__options .tournamentTags__publicToggle strong {
  color: var(--text-strong, #0f172a);
  font-size: 13px;
}
.tournamentTagEditor__actions {
  display: flex;
  justify-content: flex-end;
  gap: 9px;
  margin-top: 18px;
  padding-top: 14px;
  border-top: 1px solid var(--border-subtle, #e2e8f0);
}
@media (max-width: 620px) {
  .tournamentTagEditor__options {
    grid-template-columns: 1fr;
  }
}
@media (max-width: 760px) {
  .tournamentTags__pageHeader {
    width: calc(100% + 32px);
    min-height: 0;
    align-items: flex-start;
    flex-direction: column;
    margin-left: -16px;
    padding: 16px;
  }
  .tournamentTags__search {
    width: 100%;
    margin-left: 0;
  }
  .tournamentTags__searchWrap {
    width: 100%;
  }
  .tournamentTags__card {
    overflow-x: auto;
  }
  .tournamentTags__create {
    margin-left: 0;
  }
  .tournamentTags__selection {
    align-items: flex-start;
    flex-direction: column;
  }
  .tournamentTags__selection > div {
    flex-wrap: wrap;
  }
  .tournamentTags__pagination {
    flex-wrap: wrap;
  }
}
`, "",{"version":3,"sources":["webpack://./src/views/GenericView/AdminSUView/TournamentTags/TournamentTags.css"],"names":[],"mappings":"AAAA;EACE,WAAW;EACX,8BAA8B;EAC9B,oBAAoB;EACpB,wCAAwC;EACxC,gCAAgC;EAChC,mEAAmE;AACrE;AACA;EACE,aAAa;EACb,wBAAwB;EACxB,gBAAgB;EAChB,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,0BAA0B;EAC1B,kBAAkB;EAClB,sDAAsD;EACtD,qCAAqC;AACvC;AACA;EACE,YAAY;AACd;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;EAChB,iBAAiB;AACnB;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,WAAW;EACX,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,qCAAqC;EACrC,6CAA6C;AAC/C;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;EACf,8BAA8B;EAC9B,iBAAiB;AACnB;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,iBAAiB;EACjB,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,YAAY;EACZ,cAAc;EACd,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,oBAAoB;EACpB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,YAAY;EACZ,YAAY;EACZ,cAAc;EACd,eAAe;EACf,gDAAgD;EAChD,kBAAkB;EAClB,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,kBAAkB;EAClB,YAAY;AACd;AACA;EACE,WAAW;EACX,mBAAmB;AACrB;AACA;EACE,kBAAkB;EAClB,QAAQ;EACR,UAAU;EACV,WAAW;EACX,YAAY;EACZ,UAAU;EACV,2BAA2B;EAC3B,SAAS;EACT,kBAAkB;EAClB,uBAAuB;EACvB,iCAAiC;EACjC,eAAe;EACf,cAAc;EACd,eAAe;AACjB;AACA;EACE,0CAA0C;EAC1C,kCAAkC;AACpC;AACA;EACE,UAAU;EACV,uCAAuC;EACvC,8CAA8C;AAChD;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,iBAAiB;AACnB;AACA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,yCAAyC;EACzC,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,eAAe;AACjB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,SAAS;EACT,mBAAmB;EACnB,kBAAkB;EAClB,0CAA0C;EAC1C,kBAAkB;EAClB,mCAAmC;EACnC,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;AACV;AACA;EACE,iBAAiB;EACjB,+CAA+C;EAC/C,mBAAmB;EACnB,gBAAgB;EAChB,8DAA8D;AAChE;AACA;EACE,WAAW;EACX,yBAAyB;EACzB,iBAAiB;AACnB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,oCAAoC;EACpC,iCAAiC;EACjC,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;AACA;EACE,UAAU;EACV,SAAS;EACT,uBAAuB;EACvB,cAAc;EACd,aAAa;EACb,uBAAuB;EACvB,uBAAuB;EACvB,eAAe;AACjB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,kBAAkB;EAClB,sDAAsD;EACtD,gCAAgC;EAChC,eAAe;EACf,sBAAsB;AACxB;AACA;EACE,gBAAgB;AAClB;AACA;EACE,eAAe;EACf,iCAAiC;AACnC;AACA;;EAEE,oCAAoC;AACtC;AACA;EACE,eAAe;EACf,mCAAmC;AACrC;AACA;EACE,iBAAiB;EACjB,oBAAoB;EACpB,mBAAmB;AACrB;AACA;;;EAGE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;AACA;;EAEE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,UAAU;EACV,sBAAsB;EACtB,kBAAkB;EAClB,oDAAoD;EACpD,eAAe;AACjB;AACA;EACE,iDAAiD;AACnD;AACA;EACE,gBAAgB;AAClB;AACA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,gBAAgB;EAChB,SAAS;EACT,gCAAgC;EAChC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;AACV;AACA;EACE,WAAW;EACX,6BAA6B;AAC/B;AACA;EACE,WAAW;EACX,YAAY;EACZ,uCAAuC;AACzC;AACA;EACE,gBAAgB;EAChB,eAAe;EACf,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,UAAU;EACV,WAAW;EACX,kBAAkB;AACpB;AACA;EACE,gBAAgB;EAChB,gBAAgB;EAChB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,cAAc;EACd,oBAAoB;EACpB,oBAAoB;EACpB,mBAAmB;EACnB,qCAAqC;EACrC,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,oCAAoC;EACpC,gCAAgC;AAClC;AACA;EACE,6BAA6B;EAC7B,kBAAkB;EAClB,4CAA4C;AAC9C;AACA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;EACnB,yBAAyB;EACzB,QAAQ;EACR,eAAe;EACf,iCAAiC;EACjC,eAAe;AACjB;AACA;EACE,aAAa;EACb,uBAAuB;EACvB,SAAS;EACT,mBAAmB;AACrB;AACA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kCAAkC;EAClC,8BAA8B;EAC9B,mDAAmD;AACrD;AACA;EACE,SAAS;EACT,kCAAkC;EAClC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,aAAa;EACb,eAAe;EACf,QAAQ;EACR,cAAc;AAChB;AACA;EACE,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,wBAAwB;AAC1B;AACA;EACE,6BAA6B;AAC/B;AACA;EACE,2BAA2B;EAC3B,0BAA0B;EAC1B,6BAA6B;EAC7B,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,gDAAgD;EAChD,8CAA8C;EAC9C,sBAAsB;AACxB;AACA;EACE,gDAAgD;EAChD,8CAA8C;AAChD;AACA;EACE,0DAA0D;EAC1D,8BAA8B;EAC9B,wDAAwD;AAC1D;AACA;EACE,kCAAkC;EAClC,iEAAiE;EACjE,2BAA2B;AAC7B;AACA;EACE,kCAAkC;EAClC,yEAAyE;EACzE,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,qBAAqB;EACrB,gBAAgB;AAClB;AACA;EACE,uBAAuB;EACvB,gCAAgC;AAClC;AACA;EACE,mBAAmB;EACnB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;EACE,cAAc;EACd,gBAAgB;AAClB;AACA;;EAEE,cAAc;EACd,kBAAkB;EAClB,iCAAiC;EACjC,eAAe;EACf,gBAAgB;AAClB;AACA;;EAEE,WAAW;EACX,gDAAgD;EAChD,kBAAkB;EAClB,UAAU;EACV,gBAAgB;EAChB,kCAAkC;EAClC,aAAa;AACf;AACA;EACE,YAAY;EACZ,eAAe;AACjB;AACA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,gBAAgB;AAClB;AACA;;EAEE,0CAA0C;EAC1C,mEAAmE;AACrE;AACA;EACE,cAAc;EACd,eAAe;EACf,8BAA8B;EAC9B,eAAe;EACf,kBAAkB;AACpB;AACA;EACE,aAAa;AACf;AACA;EACE,aAAa;EACb,gEAAgE;EAChE,SAAS;EACT,mBAAmB;EACnB,eAAe;EACf,aAAa;EACb,+CAA+C;EAC/C,mBAAmB;EACnB,oCAAoC;AACtC;AACA;EACE,uBAAuB;EACvB,aAAa;AACf;AACA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,iCAAiC;EACjC,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;AACA;EACE,kCAAkC;EAClC,eAAe;AACjB;AACA;EACE,aAAa;EACb,yBAAyB;EACzB,QAAQ;EACR,gBAAgB;EAChB,iBAAiB;EACjB,mDAAmD;AACrD;AACA;EACE;IACE,0BAA0B;EAC5B;AACF;AACA;EACE;IACE,wBAAwB;IACxB,aAAa;IACb,uBAAuB;IACvB,sBAAsB;IACtB,kBAAkB;IAClB,aAAa;EACf;EACA;IACE,WAAW;IACX,cAAc;EAChB;EACA;IACE,WAAW;EACb;EACA;IACE,gBAAgB;EAClB;EACA;IACE,cAAc;EAChB;EACA;IACE,uBAAuB;IACvB,sBAAsB;EACxB;EACA;IACE,eAAe;EACjB;EACA;IACE,eAAe;EACjB;AACF","sourcesContent":[".tournamentTagsPage {\n  width: 100%;\n  min-height: calc(100vh - 76px);\n  padding-bottom: 32px;\n  background: var(--surface-page, #f8fafc);\n  color: var(--text-body, #334155);\n  font-family: var(--font-body, 'Public Sans', system-ui, sans-serif);\n}\n.tournamentTags__pageHeader {\n  display: flex;\n  width: calc(100% + 56px);\n  min-height: 96px;\n  align-items: center;\n  justify-content: space-between;\n  gap: 24px;\n  margin: -20px 0 22px -28px;\n  padding: 16px 28px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--surface-card, #fff);\n}\n.tournamentTags__heading {\n  min-width: 0;\n}\n.tournamentTags__titleRow {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n.tournamentTags__titleRow h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-display, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  font-weight: 800;\n  line-height: 1.15;\n}\n.tournamentTags__heading p {\n  max-width: 820px;\n  margin: 6px 0 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.45;\n}\n.tournamentTags__mainCard {\n  width: 100%;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 14px;\n  background: var(--surface-card, #fff);\n  box-shadow: 0 5px 18px rgba(15, 23, 42, 0.06);\n}\n.tournamentTags__toolbar {\n  display: flex;\n  align-items: center;\n  gap: 12px;\n  flex-wrap: wrap;\n  justify-content: space-between;\n  padding: 0 0 14px;\n}\n.tournamentTags__toolbar h1 {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 24px;\n  line-height: 1.15;\n  font-weight: 800;\n}\n.tournamentTags__count {\n  min-width: 28px;\n  height: 22px;\n  padding: 0 9px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 999px;\n  background: var(--slate-150, #eef2f7);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 800;\n}\n.tournamentTags__search {\n  width: 280px;\n  height: 40px;\n  margin-left: 0;\n  padding: 0 12px;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n}\n.tournamentTags__searchWrap {\n  position: relative;\n  width: 280px;\n}\n.tournamentTags__searchWrap .tournamentTags__search {\n  width: 100%;\n  padding-right: 38px;\n}\n.tournamentTags__searchWrap > button {\n  position: absolute;\n  top: 50%;\n  right: 7px;\n  width: 28px;\n  height: 28px;\n  padding: 0;\n  transform: translateY(-50%);\n  border: 0;\n  border-radius: 7px;\n  background: transparent;\n  color: var(--text-muted, #64748b);\n  font-size: 20px;\n  line-height: 1;\n  cursor: pointer;\n}\n.tournamentTags__searchWrap > button:hover {\n  background: var(--surface-sunken, #f1f5f9);\n  color: var(--text-strong, #0f172a);\n}\n.tournamentTags__search:focus {\n  outline: 0;\n  border-color: var(--brand-500, #287eb1);\n  box-shadow: 0 0 0 3px rgba(40, 126, 177, 0.12);\n}\n.tournamentTags__create {\n  margin-left: auto;\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n}\n.tournamentTags__intro {\n  max-width: 760px;\n  margin: 8px 0 18px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.55;\n}\n.tournamentTags__error {\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--red-100, #f9d4d9);\n  border-radius: 8px;\n  background: var(--red-50, #fdecee);\n  color: var(--red-700, #a52836);\n  font-size: 13px;\n}\n.tournamentTags__selection {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 16px;\n  margin-bottom: 12px;\n  padding: 10px 12px;\n  border: 1px solid var(--blue-100, #cfe5f2);\n  border-radius: 8px;\n  background: var(--blue-50, #eef7fc);\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n  font-weight: 700;\n}\n.tournamentTags__selection > div {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n}\n.tournamentTags__selection .sit-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n}\n.tournamentTags__card {\n  overflow: visible;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: #fff;\n  box-shadow: var(--shadow-sm, 0 1px 3px rgba(15, 23, 42, 0.08));\n}\n.tournamentTags__table {\n  width: 100%;\n  border-collapse: separate;\n  border-spacing: 0;\n}\n.tournamentTags__table th {\n  padding: 11px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  background: var(--slate-50, #f8fafc);\n  color: var(--text-muted, #64748b);\n  text-align: left;\n  font-size: 11px;\n  font-weight: 800;\n  letter-spacing: 0.05em;\n  text-transform: uppercase;\n}\n.tournamentTags__table th button {\n  padding: 0;\n  border: 0;\n  background: transparent;\n  color: inherit;\n  font: inherit;\n  letter-spacing: inherit;\n  text-transform: inherit;\n  cursor: pointer;\n}\n.tournamentTags__table th button span {\n  margin-left: 5px;\n}\n.tournamentTags__table td {\n  padding: 12px 14px;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0);\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  vertical-align: middle;\n}\n.tournamentTags__table tr:last-child td {\n  border-bottom: 0;\n}\n.tournamentTags__table tbody tr {\n  cursor: pointer;\n  transition: background 0.15s ease;\n}\n.tournamentTags__table tbody tr:hover,\n.tournamentTags__table tbody tr.isSelected {\n  background: var(--slate-50, #f8fafc);\n}\n.tournamentTags__table tbody tr.tournamentTags__inlineRow {\n  cursor: default;\n  background: var(--blue-50, #f4f9fc);\n}\n.tournamentTags__inlineRow td {\n  padding-top: 14px;\n  padding-bottom: 14px;\n  vertical-align: top;\n}\n.tournamentTags__inlineRow input[type='text'],\n.tournamentTags__inlineRow input:not([type]),\n.tournamentTags__inlineRow textarea {\n  width: 100%;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: 0;\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n}\n.tournamentTags__inlineRow input[type='text'],\n.tournamentTags__inlineRow input:not([type]) {\n  height: 40px;\n  padding: 0 12px;\n}\n.tournamentTags__inlineRow textarea {\n  min-height: 72px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n.tournamentTags__inlineRow input:focus,\n.tournamentTags__inlineRow textarea:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.tournamentTags__inlineName em {\n  display: block;\n  margin-top: 5px;\n  color: var(--red-600, #c4313f);\n  font-size: 12px;\n  font-style: normal;\n}\n.tournamentTags__swatches {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin-top: 10px;\n}\n.tournamentTags__swatch {\n  width: 24px;\n  height: 24px;\n  padding: 0;\n  border: 2px solid #fff;\n  border-radius: 6px;\n  box-shadow: 0 0 0 1px var(--border-default, #cbd5e1);\n  cursor: pointer;\n}\n.tournamentTags__swatch.isActive {\n  box-shadow: 0 0 0 2px var(--text-strong, #0f172a);\n}\n.tournamentTags__inlinePreview {\n  margin-top: 10px;\n}\n.tournamentTags__publicToggle {\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  min-height: 40px;\n  margin: 0;\n  color: var(--text-body, #334155);\n  font-size: 13px;\n  font-weight: 650;\n}\n.tournamentTags__publicToggle input {\n  width: 17px;\n  height: 17px;\n  accent-color: var(--brand-600, #1f6f9f);\n}\n.tournamentTags__inlineActions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n}\n.tournamentTags__check {\n  width: 44px;\n  text-align: center !important;\n}\n.tournamentTags__check input {\n  width: 16px;\n  height: 16px;\n  accent-color: var(--brand-600, #1f6f9f);\n}\n.tournamentTags__badge {\n  min-height: 26px;\n  padding: 0 10px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  gap: 7px;\n  white-space: nowrap;\n  font-size: 13px;\n  font-weight: 600;\n}\n.tournamentTags__badge i {\n  width: 8px;\n  height: 8px;\n  border-radius: 6px;\n}\n.tournamentTags__description {\n  min-width: 240px;\n  max-width: 560px;\n  color: var(--text-muted, #64748b) !important;\n}\n.tournamentTags__visibility {\n  min-height: 24px;\n  padding: 0 9px;\n  border-radius: 999px;\n  display: inline-flex;\n  align-items: center;\n  background: var(--slate-150, #eef2f7);\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n.tournamentTags__visibility.isPublic {\n  background: var(--green-50, #edf8f2);\n  color: var(--green-700, #287a50);\n}\n.tournamentTags__empty {\n  padding: 32px 14px !important;\n  text-align: center;\n  color: var(--text-muted, #64748b) !important;\n}\n.tournamentTags__pagination {\n  min-height: 56px;\n  display: flex;\n  align-items: center;\n  justify-content: flex-end;\n  gap: 8px;\n  padding: 10px 0;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n}\n.tournamentTagsDelete {\n  display: flex;\n  align-items: flex-start;\n  gap: 13px;\n  white-space: normal;\n}\n.tournamentTagsDelete__icon {\n  flex: 0 0 auto;\n  width: 36px;\n  height: 36px;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  border-radius: 8px;\n  background: var(--red-50, #fff1f2);\n  color: var(--red-600, #c4313f);\n  box-shadow: inset 0 0 0 1px var(--red-100, #ffd5da);\n}\n.tournamentTagsDelete p {\n  margin: 0;\n  color: var(--text-strong, #0f172a);\n  font-size: 14px;\n  font-weight: 700;\n}\n.tournamentTagsDelete__tags {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 7px;\n  margin: 12px 0;\n}\n.tournamentTagsDelete .tournamentTagsDelete__note {\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  font-weight: 500;\n  line-height: 1.5;\n}\n.tournamentTagsDeleteModal .modal-header {\n  padding: 14px 18px !important;\n}\n.tournamentTagsDeleteModal .modal-body {\n  padding: 18px !important;\n}\n.tournamentTagsDeleteModal .modal-footer {\n  padding: 12px 18px !important;\n}\n.tournamentTagsDeleteModal .modal-footer .btn {\n  min-height: 36px !important;\n  padding: 0 14px !important;\n  border-radius: 8px !important;\n  font-size: 13px;\n  font-weight: 700;\n}\n.tournamentTagsDeleteModal .modal-footer .btn-primary {\n  border-color: var(--red-500, #da4453) !important;\n  background: var(--red-500, #da4453) !important;\n  color: #fff !important;\n}\n.tournamentTagsDeleteModal .modal-footer .btn-primary:hover {\n  border-color: var(--red-600, #c4313f) !important;\n  background: var(--red-600, #c4313f) !important;\n}\n.tournamentTagEditorModal .modal-content {\n  border: 1px solid var(--border-subtle, #dbe3ec) !important;\n  border-radius: 14px !important;\n  box-shadow: 0 24px 64px rgba(15, 23, 42, 0.2) !important;\n}\n.tournamentTagEditorModal .modal-header {\n  padding: 18px 20px 14px !important;\n  border-bottom: 1px solid var(--border-subtle, #e2e8f0) !important;\n  background: #fff !important;\n}\n.tournamentTagEditorModal .modal-title {\n  color: var(--text-strong, #0f172a);\n  font-family: var(--font-heading, 'Hanken Grotesk', system-ui, sans-serif);\n  font-size: 19px;\n  font-weight: 800;\n}\n.tournamentTagEditorModal .modal-body {\n  padding: 0 !important;\n  background: #fff;\n}\n.tournamentTagEditor {\n  padding: 18px 20px 16px;\n  color: var(--text-body, #334155);\n}\n.tournamentTagEditor__intro {\n  margin-bottom: 17px;\n  color: var(--text-muted, #64748b);\n  font-size: 13px;\n  line-height: 1.5;\n}\n.tournamentTagEditor__field {\n  display: block;\n  margin: 0 0 16px;\n}\n.tournamentTagEditor__field > span,\n.tournamentTagEditor__label {\n  display: block;\n  margin-bottom: 6px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 700;\n}\n.tournamentTagEditor__field input,\n.tournamentTagEditor__field textarea {\n  width: 100%;\n  border: 1px solid var(--border-default, #cbd5e1);\n  border-radius: 8px;\n  outline: 0;\n  background: #fff;\n  color: var(--text-strong, #0f172a);\n  font: inherit;\n}\n.tournamentTagEditor__field input {\n  height: 40px;\n  padding: 0 12px;\n}\n.tournamentTagEditor__field textarea {\n  min-height: 88px;\n  padding: 10px 12px;\n  resize: vertical;\n}\n.tournamentTagEditor__field input:focus,\n.tournamentTagEditor__field textarea:focus {\n  border-color: var(--border-brand, #6fb1df);\n  box-shadow: var(--shadow-focus, 0 0 0 3px rgba(34, 126, 189, 0.18));\n}\n.tournamentTagEditor__field em {\n  display: block;\n  margin-top: 6px;\n  color: var(--red-600, #c4313f);\n  font-size: 12px;\n  font-style: normal;\n}\n.tournamentTagEditor .tournamentTags__swatches {\n  margin-top: 0;\n}\n.tournamentTagEditor__options {\n  display: grid;\n  grid-template-columns: minmax(180px, 0.8fr) minmax(260px, 1.2fr);\n  gap: 18px;\n  align-items: center;\n  margin-top: 2px;\n  padding: 14px;\n  border: 1px solid var(--border-subtle, #e2e8f0);\n  border-radius: 10px;\n  background: var(--slate-50, #f8fafc);\n}\n.tournamentTagEditor__options .tournamentTags__publicToggle {\n  align-items: flex-start;\n  min-height: 0;\n}\n.tournamentTagEditor__options .tournamentTags__publicToggle > span {\n  display: flex;\n  flex-direction: column;\n  gap: 3px;\n  color: var(--text-muted, #64748b);\n  font-size: 12px;\n  font-weight: 500;\n  line-height: 1.4;\n}\n.tournamentTagEditor__options .tournamentTags__publicToggle strong {\n  color: var(--text-strong, #0f172a);\n  font-size: 13px;\n}\n.tournamentTagEditor__actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 9px;\n  margin-top: 18px;\n  padding-top: 14px;\n  border-top: 1px solid var(--border-subtle, #e2e8f0);\n}\n@media (max-width: 620px) {\n  .tournamentTagEditor__options {\n    grid-template-columns: 1fr;\n  }\n}\n@media (max-width: 760px) {\n  .tournamentTags__pageHeader {\n    width: calc(100% + 32px);\n    min-height: 0;\n    align-items: flex-start;\n    flex-direction: column;\n    margin-left: -16px;\n    padding: 16px;\n  }\n  .tournamentTags__search {\n    width: 100%;\n    margin-left: 0;\n  }\n  .tournamentTags__searchWrap {\n    width: 100%;\n  }\n  .tournamentTags__card {\n    overflow-x: auto;\n  }\n  .tournamentTags__create {\n    margin-left: 0;\n  }\n  .tournamentTags__selection {\n    align-items: flex-start;\n    flex-direction: column;\n  }\n  .tournamentTags__selection > div {\n    flex-wrap: wrap;\n  }\n  .tournamentTags__pagination {\n    flex-wrap: wrap;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
